// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2c11S","header":"MergedInvoice_header__-DwOe"};